export const planWeeks = [
  {
    week: "Semana 1",
    days: "Días 1–7",
    title: "Preparación",
    tasks: ["Elige tus 3 productos estrella", "Organiza tu espacio y herramientas", "Define el nombre de tu emprendimiento"],
  },
  {
    week: "Semana 2",
    days: "Días 8–14",
    title: "Recetas y costos",
    tasks: ["Prueba y estandariza tus recetas", "Calcula el costo de cada receta", "Define tus precios con margen"],
  },
  {
    week: "Semana 3",
    days: "Días 15–21",
    title: "Instagram, catálogo y WhatsApp",
    tasks: ["Arma tu perfil y fotografía tus productos", "Prepara tu catálogo con precios", "Configura WhatsApp y tus mensajes listos"],
  },
  {
    week: "Semana 4",
    days: "Días 22–30",
    title: "Organización y primeros ofrecimientos",
    tasks: ["Organiza producción, entregas y cobros", "Ofrece tus productos a tus primeros contactos", "Anuncia tu lanzamiento"],
  },
];
